// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advanced-cropper-line-wrapper--north, .advanced-cropper-line-wrapper--south {
  height: 12px;
  width: 100%; }

.advanced-cropper-line-wrapper--north {
  cursor: n-resize; }

.advanced-cropper-line-wrapper--south {
  cursor: s-resize; }

.advanced-cropper-line-wrapper--east, .advanced-cropper-line-wrapper--west {
  width: 12px;
  height: 100%; }

.advanced-cropper-line-wrapper--east {
  cursor: e-resize; }

.advanced-cropper-line-wrapper--west {
  cursor: w-resize; }

.advanced-cropper-line-wrapper--disabled {
  cursor: auto; }

.advanced-cropper-line-wrapper__content {
  position: absolute; }
  .advanced-cropper-line-wrapper__content--east, .advanced-cropper-line-wrapper__content--west {
    height: 100%; }
  .advanced-cropper-line-wrapper__content--north, .advanced-cropper-line-wrapper__content--south {
    width: 100%; }
  .advanced-cropper-line-wrapper__content--east {
    left: 50%;
    transform: translateX(-100%); }
  .advanced-cropper-line-wrapper__content--west {
    right: 50%;
    transform: translateX(100%); }
  .advanced-cropper-line-wrapper__content--north {
    top: 50%; }
  .advanced-cropper-line-wrapper__content--south {
    bottom: 50%; }

.advanced-cropper-handler-wrapper {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px; }
  .advanced-cropper-handler-wrapper__draggable {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center; }
  .advanced-cropper-handler-wrapper--west-north {
    cursor: nw-resize; }
  .advanced-cropper-handler-wrapper--north {
    cursor: n-resize; }
  .advanced-cropper-handler-wrapper--east-north {
    cursor: ne-resize; }
  .advanced-cropper-handler-wrapper--east {
    cursor: e-resize; }
  .advanced-cropper-handler-wrapper--east-south {
    cursor: se-resize; }
  .advanced-cropper-handler-wrapper--south {
    cursor: s-resize; }
  .advanced-cropper-handler-wrapper--west-south {
    cursor: sw-resize; }
  .advanced-cropper-handler-wrapper--west {
    cursor: w-resize; }
  .advanced-cropper-handler-wrapper--disabled {
    cursor: auto; }

.advanced-cropper-bounding-box {
  position: relative;
  height: 100%;
  width: 100%; }
  .advanced-cropper-bounding-box__handler-wrapper {
    position: absolute; }
    .advanced-cropper-bounding-box__handler-wrapper--east, .advanced-cropper-bounding-box__handler-wrapper--west {
      top: 50%;
      transform: translateY(-50%);
      height: 100%; }
    .advanced-cropper-bounding-box__handler-wrapper--south, .advanced-cropper-bounding-box__handler-wrapper--north {
      left: 50%;
      transform: translateX(-50%);
      width: 100%; }
    .advanced-cropper-bounding-box__handler-wrapper--west, .advanced-cropper-bounding-box__handler-wrapper--west-north, .advanced-cropper-bounding-box__handler-wrapper--west-south {
      left: 0; }
    .advanced-cropper-bounding-box__handler-wrapper--east, .advanced-cropper-bounding-box__handler-wrapper--east-north, .advanced-cropper-bounding-box__handler-wrapper--east-south {
      left: 100%; }
    .advanced-cropper-bounding-box__handler-wrapper--north, .advanced-cropper-bounding-box__handler-wrapper--west-north, .advanced-cropper-bounding-box__handler-wrapper--east-north {
      top: 0; }
    .advanced-cropper-bounding-box__handler-wrapper--south, .advanced-cropper-bounding-box__handler-wrapper--west-south, .advanced-cropper-bounding-box__handler-wrapper--east-south {
      top: 100%; }
  .advanced-cropper-bounding-box__handler {
    position: absolute; }
    .advanced-cropper-bounding-box__handler--west-north {
      left: 0;
      top: 0; }
    .advanced-cropper-bounding-box__handler--north {
      left: 50%;
      top: 0; }
    .advanced-cropper-bounding-box__handler--east-north {
      left: 100%;
      top: 0; }
    .advanced-cropper-bounding-box__handler--east {
      left: 100%;
      top: 50%; }
    .advanced-cropper-bounding-box__handler--east-south {
      left: 100%;
      top: 100%; }
    .advanced-cropper-bounding-box__handler--south {
      left: 50%;
      top: 100%; }
    .advanced-cropper-bounding-box__handler--west-south {
      left: 0;
      top: 100%; }
    .advanced-cropper-bounding-box__handler--west {
      left: 0;
      top: 50%; }
  .advanced-cropper-bounding-box__line {
    position: absolute; }
    .advanced-cropper-bounding-box__line--north, .advanced-cropper-bounding-box__line--south {
      left: 0;
      transform: translateY(-50%); }
    .advanced-cropper-bounding-box__line--north {
      top: 0; }
    .advanced-cropper-bounding-box__line--south {
      top: 100%; }
    .advanced-cropper-bounding-box__line--west, .advanced-cropper-bounding-box__line--east {
      top: 0;
      transform: translateX(-50%); }
    .advanced-cropper-bounding-box__line--west {
      left: 0; }
    .advanced-cropper-bounding-box__line--east {
      left: 100%; }

.advanced-cropper-artificial-transition {
  will-change: transform; }

.advanced-cropper-background-image {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  position: absolute;
  transform-origin: center;
  pointer-events: none;
  max-width: none !important; }

.advanced-cropper-canvas {
  display: none; }

.advanced-cropper-source {
  width: 1px;
  height: 1px;
  visibility: hidden;
  position: absolute;
  opacity: 0; }

.advanced-cropper-fade {
  visibility: hidden;
  opacity: 0;
  transition: 0.5s;
  display: flex;
  flex-direction: column; }
  .advanced-cropper-fade--visible {
    opacity: 1;
    visibility: visible; }

.advanced-cropper-wrapper__fade {
  flex-grow: 1;
  min-height: 0; }

.advanced-cropper-stencil-grid {
  display: table;
  border-collapse: collapse;
  table-layout: fixed;
  opacity: 0;
  transition: opacity 0.3s; }
  .advanced-cropper-stencil-grid--visible {
    opacity: 1; }
  .advanced-cropper-stencil-grid__row {
    display: table-row; }
  .advanced-cropper-stencil-grid__cell {
    display: table-cell;
    width: 1%;
    height: 1%;
    border: currentColor solid 1px; }
    .advanced-cropper-stencil-grid__cell--top {
      border-top-color: transparent; }
    .advanced-cropper-stencil-grid__cell--left {
      border-left-color: transparent; }
    .advanced-cropper-stencil-grid__cell--right {
      border-right-color: transparent; }
    .advanced-cropper-stencil-grid__cell--bottom {
      border-bottom-color: transparent; }

.advanced-cropper-stencil-overlay {
  box-sizing: content-box;
  box-shadow: 0 0 0 1000px currentColor;
  pointer-events: none;
  width: 100%;
  height: 100%;
  position: absolute;
  -webkit-backface-visibility: hidden; }

.advanced-cropper-stencil-wrapper {
  will-change: transform; }

.advanced-cropper-boundary {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  direction: ltr;
  position: relative; }
  .advanced-cropper-boundary__content {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0; }
  .advanced-cropper-boundary__stretcher {
    pointer-events: none;
    position: relative;
    max-width: 100%;
    max-height: 100%; }

.advanced-cropper-circle-stencil {
  position: absolute;
  height: 100%;
  width: 100%;
  box-sizing: content-box;
  -webkit-backface-visibility: hidden;
  -webkit-transform-style: preserve-3d; }
  .advanced-cropper-circle-stencil__overlay {
    border-radius: 50%;
    overflow: hidden; }
  .advanced-cropper-circle-stencil__preview {
    border-radius: 50%; }
  .advanced-cropper-circle-stencil__draggable-area, .advanced-cropper-circle-stencil__overlay, .advanced-cropper-circle-stencil__preview, .advanced-cropper-circle-stencil__grid {
    position: absolute;
    height: 100%;
    width: 100%; }
  .advanced-cropper-circle-stencil--movable {
    cursor: move; }

.advanced-cropper-rectangle-stencil {
  position: absolute;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  -webkit-backface-visibility: hidden;
  -webkit-transform-style: preserve-3d; }
  .advanced-cropper-rectangle-stencil__draggable-area, .advanced-cropper-rectangle-stencil__overlay, .advanced-cropper-rectangle-stencil__preview, .advanced-cropper-rectangle-stencil__grid {
    position: absolute;
    height: 100%;
    width: 100%; }
  .advanced-cropper-rectangle-stencil--movable {
    cursor: move; }

.advanced-cropper-simple-line {
  background: none;
  border-width: 0; }
  .advanced-cropper-simple-line--south, .advanced-cropper-simple-line--north {
    height: 0;
    width: 100%; }
  .advanced-cropper-simple-line--east, .advanced-cropper-simple-line--west {
    height: 100%;
    width: 0; }
  .advanced-cropper-simple-line--east {
    border-right-width: 1px; }
  .advanced-cropper-simple-line--west {
    border-left-width: 1px; }
  .advanced-cropper-simple-line--south {
    border-bottom-width: 1px; }
  .advanced-cropper-simple-line--north {
    border-top-width: 1px; }

.advanced-cropper-simple-handler {
  display: block; }

.advanced-cropper-preview {
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column; }
  .advanced-cropper-preview__content {
    overflow: hidden;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%); }
  .advanced-cropper-preview__image {
    display: none;
    pointer-events: none;
    position: absolute;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    transform-origin: center;
    max-width: none !important; }
    .advanced-cropper-preview__image--visible {
      display: block; }
  .advanced-cropper-preview__boundary {
    flex-grow: 1;
    min-height: 0;
    min-width: 0; }

.cropper-preview-wrapper__fade {
  flex-grow: 1;
  min-height: 0;
  width: 100%; }

.advanced-cropper {
  overflow: hidden;
  max-height: 100%;
  background: black;
  position: relative;
  display: flex;
  flex-direction: column;
  color: white; }
  .advanced-cropper__boundary {
    flex-grow: 1;
    min-height: 0;
    min-width: 0; }
  .advanced-cropper__wrapper, .advanced-cropper__background-wrapper {
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    position: absolute; }
  .advanced-cropper__stencil-wrapper {
    position: absolute; }
  .advanced-cropper * {
    box-sizing: border-box; }

.advanced-cropper-simple-handler {
  background: currentColor;
  height: 10px;
  width: 10px; }

.advanced-cropper-simple-line {
  transition: border 0.5s;
  border-color: rgba(255, 255, 255, 0.3);
  border-style: solid; }
  .advanced-cropper-simple-line--hover {
    border-color: white; }

.advanced-cropper-circle-stencil__preview {
  border: solid 2px rgba(255, 255, 255, 0.2); }

.advanced-cropper-stencil-overlay {
  color: rgba(0, 0, 0, 0.5); }

.advanced-cropper-stencil-grid {
  color: rgba(255, 255, 255, 0.4); }
`, "",{"version":3,"sources":["webpack://./node_modules/react-advanced-cropper/dist/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW,EAAE;;AAEf;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,YAAY,EAAE;;AAEhB;EACE,kBAAkB,EAAE;EACpB;IACE,YAAY,EAAE;EAChB;IACE,WAAW,EAAE;EACf;IACE,SAAS;IACT,4BAA4B,EAAE;EAChC;IACE,UAAU;IACV,2BAA2B,EAAE;EAC/B;IACE,QAAQ,EAAE;EACZ;IACE,WAAW,EAAE;;AAEjB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,YAAY,EAAE;EACd;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAE;EAC3B;IACE,iBAAiB,EAAE;EACrB;IACE,gBAAgB,EAAE;EACpB;IACE,iBAAiB,EAAE;EACrB;IACE,gBAAgB,EAAE;EACpB;IACE,iBAAiB,EAAE;EACrB;IACE,gBAAgB,EAAE;EACpB;IACE,iBAAiB,EAAE;EACrB;IACE,gBAAgB,EAAE;EACpB;IACE,YAAY,EAAE;;AAElB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW,EAAE;EACb;IACE,kBAAkB,EAAE;IACpB;MACE,QAAQ;MACR,2BAA2B;MAC3B,YAAY,EAAE;IAChB;MACE,SAAS;MACT,2BAA2B;MAC3B,WAAW,EAAE;IACf;MACE,OAAO,EAAE;IACX;MACE,UAAU,EAAE;IACd;MACE,MAAM,EAAE;IACV;MACE,SAAS,EAAE;EACf;IACE,kBAAkB,EAAE;IACpB;MACE,OAAO;MACP,MAAM,EAAE;IACV;MACE,SAAS;MACT,MAAM,EAAE;IACV;MACE,UAAU;MACV,MAAM,EAAE;IACV;MACE,UAAU;MACV,QAAQ,EAAE;IACZ;MACE,UAAU;MACV,SAAS,EAAE;IACb;MACE,SAAS;MACT,SAAS,EAAE;IACb;MACE,OAAO;MACP,SAAS,EAAE;IACb;MACE,OAAO;MACP,QAAQ,EAAE;EACd;IACE,kBAAkB,EAAE;IACpB;MACE,OAAO;MACP,2BAA2B,EAAE;IAC/B;MACE,MAAM,EAAE;IACV;MACE,SAAS,EAAE;IACb;MACE,MAAM;MACN,2BAA2B,EAAE;IAC/B;MACE,OAAO,EAAE;IACX;MACE,UAAU,EAAE;;AAElB;EACE,sBAAsB,EAAE;;AAE1B;EACE,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,0BAA0B,EAAE;;AAE9B;EACE,aAAa,EAAE;;AAEjB;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU,EAAE;;AAEd;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB,EAAE;EACxB;IACE,UAAU;IACV,mBAAmB,EAAE;;AAEzB;EACE,YAAY;EACZ,aAAa,EAAE;;AAEjB;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,wBAAwB,EAAE;EAC1B;IACE,UAAU,EAAE;EACd;IACE,kBAAkB,EAAE;EACtB;IACE,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,8BAA8B,EAAE;IAChC;MACE,6BAA6B,EAAE;IACjC;MACE,8BAA8B,EAAE;IAClC;MACE,+BAA+B,EAAE;IACnC;MACE,gCAAgC,EAAE;;AAExC;EACE,uBAAuB;EACvB,qCAAqC;EACrC,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC,EAAE;;AAEvC;EACE,sBAAsB,EAAE;;AAE1B;EACE,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,cAAc;EACd,kBAAkB,EAAE;EACpB;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO,EAAE;EACX;IACE,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mCAAmC;EACnC,oCAAoC,EAAE;EACtC;IACE,kBAAkB;IAClB,gBAAgB,EAAE;EACpB;IACE,kBAAkB,EAAE;EACtB;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW,EAAE;EACf;IACE,YAAY,EAAE;;AAElB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mCAAmC;EACnC,oCAAoC,EAAE;EACtC;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW,EAAE;EACf;IACE,YAAY,EAAE;;AAElB;EACE,gBAAgB;EAChB,eAAe,EAAE;EACjB;IACE,SAAS;IACT,WAAW,EAAE;EACf;IACE,YAAY;IACZ,QAAQ,EAAE;EACZ;IACE,uBAAuB,EAAE;EAC3B;IACE,sBAAsB,EAAE;EAC1B;IACE,wBAAwB,EAAE;EAC5B;IACE,qBAAqB,EAAE;;AAE3B;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB,EAAE;EACxB;IACE,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC,EAAE;EACpC;IACE,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,wBAAwB;IACxB,0BAA0B,EAAE;IAC5B;MACE,cAAc,EAAE;EACpB;IACE,YAAY;IACZ,aAAa;IACb,YAAY,EAAE;;AAElB;EACE,YAAY;EACZ,aAAa;EACb,WAAW,EAAE;;AAEf;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE;EACd;IACE,YAAY;IACZ,aAAa;IACb,YAAY,EAAE;EAChB;IACE,OAAO;IACP,MAAM;IACN,QAAQ;IACR,SAAS;IACT,kBAAkB,EAAE;EACtB;IACE,kBAAkB,EAAE;EACtB;IACE,sBAAsB,EAAE;;AAE5B;EACE,wBAAwB;EACxB,YAAY;EACZ,WAAW,EAAE;;AAEf;EACE,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB,EAAE;EACrB;IACE,mBAAmB,EAAE;;AAEzB;EACE,0CAA0C,EAAE;;AAE9C;EACE,yBAAyB,EAAE;;AAE7B;EACE,+BAA+B,EAAE","sourcesContent":[".advanced-cropper-line-wrapper--north, .advanced-cropper-line-wrapper--south {\n  height: 12px;\n  width: 100%; }\n\n.advanced-cropper-line-wrapper--north {\n  cursor: n-resize; }\n\n.advanced-cropper-line-wrapper--south {\n  cursor: s-resize; }\n\n.advanced-cropper-line-wrapper--east, .advanced-cropper-line-wrapper--west {\n  width: 12px;\n  height: 100%; }\n\n.advanced-cropper-line-wrapper--east {\n  cursor: e-resize; }\n\n.advanced-cropper-line-wrapper--west {\n  cursor: w-resize; }\n\n.advanced-cropper-line-wrapper--disabled {\n  cursor: auto; }\n\n.advanced-cropper-line-wrapper__content {\n  position: absolute; }\n  .advanced-cropper-line-wrapper__content--east, .advanced-cropper-line-wrapper__content--west {\n    height: 100%; }\n  .advanced-cropper-line-wrapper__content--north, .advanced-cropper-line-wrapper__content--south {\n    width: 100%; }\n  .advanced-cropper-line-wrapper__content--east {\n    left: 50%;\n    transform: translateX(-100%); }\n  .advanced-cropper-line-wrapper__content--west {\n    right: 50%;\n    transform: translateX(100%); }\n  .advanced-cropper-line-wrapper__content--north {\n    top: 50%; }\n  .advanced-cropper-line-wrapper__content--south {\n    bottom: 50%; }\n\n.advanced-cropper-handler-wrapper {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  width: 30px;\n  height: 30px; }\n  .advanced-cropper-handler-wrapper__draggable {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  .advanced-cropper-handler-wrapper--west-north {\n    cursor: nw-resize; }\n  .advanced-cropper-handler-wrapper--north {\n    cursor: n-resize; }\n  .advanced-cropper-handler-wrapper--east-north {\n    cursor: ne-resize; }\n  .advanced-cropper-handler-wrapper--east {\n    cursor: e-resize; }\n  .advanced-cropper-handler-wrapper--east-south {\n    cursor: se-resize; }\n  .advanced-cropper-handler-wrapper--south {\n    cursor: s-resize; }\n  .advanced-cropper-handler-wrapper--west-south {\n    cursor: sw-resize; }\n  .advanced-cropper-handler-wrapper--west {\n    cursor: w-resize; }\n  .advanced-cropper-handler-wrapper--disabled {\n    cursor: auto; }\n\n.advanced-cropper-bounding-box {\n  position: relative;\n  height: 100%;\n  width: 100%; }\n  .advanced-cropper-bounding-box__handler-wrapper {\n    position: absolute; }\n    .advanced-cropper-bounding-box__handler-wrapper--east, .advanced-cropper-bounding-box__handler-wrapper--west {\n      top: 50%;\n      transform: translateY(-50%);\n      height: 100%; }\n    .advanced-cropper-bounding-box__handler-wrapper--south, .advanced-cropper-bounding-box__handler-wrapper--north {\n      left: 50%;\n      transform: translateX(-50%);\n      width: 100%; }\n    .advanced-cropper-bounding-box__handler-wrapper--west, .advanced-cropper-bounding-box__handler-wrapper--west-north, .advanced-cropper-bounding-box__handler-wrapper--west-south {\n      left: 0; }\n    .advanced-cropper-bounding-box__handler-wrapper--east, .advanced-cropper-bounding-box__handler-wrapper--east-north, .advanced-cropper-bounding-box__handler-wrapper--east-south {\n      left: 100%; }\n    .advanced-cropper-bounding-box__handler-wrapper--north, .advanced-cropper-bounding-box__handler-wrapper--west-north, .advanced-cropper-bounding-box__handler-wrapper--east-north {\n      top: 0; }\n    .advanced-cropper-bounding-box__handler-wrapper--south, .advanced-cropper-bounding-box__handler-wrapper--west-south, .advanced-cropper-bounding-box__handler-wrapper--east-south {\n      top: 100%; }\n  .advanced-cropper-bounding-box__handler {\n    position: absolute; }\n    .advanced-cropper-bounding-box__handler--west-north {\n      left: 0;\n      top: 0; }\n    .advanced-cropper-bounding-box__handler--north {\n      left: 50%;\n      top: 0; }\n    .advanced-cropper-bounding-box__handler--east-north {\n      left: 100%;\n      top: 0; }\n    .advanced-cropper-bounding-box__handler--east {\n      left: 100%;\n      top: 50%; }\n    .advanced-cropper-bounding-box__handler--east-south {\n      left: 100%;\n      top: 100%; }\n    .advanced-cropper-bounding-box__handler--south {\n      left: 50%;\n      top: 100%; }\n    .advanced-cropper-bounding-box__handler--west-south {\n      left: 0;\n      top: 100%; }\n    .advanced-cropper-bounding-box__handler--west {\n      left: 0;\n      top: 50%; }\n  .advanced-cropper-bounding-box__line {\n    position: absolute; }\n    .advanced-cropper-bounding-box__line--north, .advanced-cropper-bounding-box__line--south {\n      left: 0;\n      transform: translateY(-50%); }\n    .advanced-cropper-bounding-box__line--north {\n      top: 0; }\n    .advanced-cropper-bounding-box__line--south {\n      top: 100%; }\n    .advanced-cropper-bounding-box__line--west, .advanced-cropper-bounding-box__line--east {\n      top: 0;\n      transform: translateX(-50%); }\n    .advanced-cropper-bounding-box__line--west {\n      left: 0; }\n    .advanced-cropper-bounding-box__line--east {\n      left: 100%; }\n\n.advanced-cropper-artificial-transition {\n  will-change: transform; }\n\n.advanced-cropper-background-image {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  position: absolute;\n  transform-origin: center;\n  pointer-events: none;\n  max-width: none !important; }\n\n.advanced-cropper-canvas {\n  display: none; }\n\n.advanced-cropper-source {\n  width: 1px;\n  height: 1px;\n  visibility: hidden;\n  position: absolute;\n  opacity: 0; }\n\n.advanced-cropper-fade {\n  visibility: hidden;\n  opacity: 0;\n  transition: 0.5s;\n  display: flex;\n  flex-direction: column; }\n  .advanced-cropper-fade--visible {\n    opacity: 1;\n    visibility: visible; }\n\n.advanced-cropper-wrapper__fade {\n  flex-grow: 1;\n  min-height: 0; }\n\n.advanced-cropper-stencil-grid {\n  display: table;\n  border-collapse: collapse;\n  table-layout: fixed;\n  opacity: 0;\n  transition: opacity 0.3s; }\n  .advanced-cropper-stencil-grid--visible {\n    opacity: 1; }\n  .advanced-cropper-stencil-grid__row {\n    display: table-row; }\n  .advanced-cropper-stencil-grid__cell {\n    display: table-cell;\n    width: 1%;\n    height: 1%;\n    border: currentColor solid 1px; }\n    .advanced-cropper-stencil-grid__cell--top {\n      border-top-color: transparent; }\n    .advanced-cropper-stencil-grid__cell--left {\n      border-left-color: transparent; }\n    .advanced-cropper-stencil-grid__cell--right {\n      border-right-color: transparent; }\n    .advanced-cropper-stencil-grid__cell--bottom {\n      border-bottom-color: transparent; }\n\n.advanced-cropper-stencil-overlay {\n  box-sizing: content-box;\n  box-shadow: 0 0 0 1000px currentColor;\n  pointer-events: none;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  -webkit-backface-visibility: hidden; }\n\n.advanced-cropper-stencil-wrapper {\n  will-change: transform; }\n\n.advanced-cropper-boundary {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  direction: ltr;\n  position: relative; }\n  .advanced-cropper-boundary__content {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0; }\n  .advanced-cropper-boundary__stretcher {\n    pointer-events: none;\n    position: relative;\n    max-width: 100%;\n    max-height: 100%; }\n\n.advanced-cropper-circle-stencil {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  box-sizing: content-box;\n  -webkit-backface-visibility: hidden;\n  -webkit-transform-style: preserve-3d; }\n  .advanced-cropper-circle-stencil__overlay {\n    border-radius: 50%;\n    overflow: hidden; }\n  .advanced-cropper-circle-stencil__preview {\n    border-radius: 50%; }\n  .advanced-cropper-circle-stencil__draggable-area, .advanced-cropper-circle-stencil__overlay, .advanced-cropper-circle-stencil__preview, .advanced-cropper-circle-stencil__grid {\n    position: absolute;\n    height: 100%;\n    width: 100%; }\n  .advanced-cropper-circle-stencil--movable {\n    cursor: move; }\n\n.advanced-cropper-rectangle-stencil {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  -webkit-backface-visibility: hidden;\n  -webkit-transform-style: preserve-3d; }\n  .advanced-cropper-rectangle-stencil__draggable-area, .advanced-cropper-rectangle-stencil__overlay, .advanced-cropper-rectangle-stencil__preview, .advanced-cropper-rectangle-stencil__grid {\n    position: absolute;\n    height: 100%;\n    width: 100%; }\n  .advanced-cropper-rectangle-stencil--movable {\n    cursor: move; }\n\n.advanced-cropper-simple-line {\n  background: none;\n  border-width: 0; }\n  .advanced-cropper-simple-line--south, .advanced-cropper-simple-line--north {\n    height: 0;\n    width: 100%; }\n  .advanced-cropper-simple-line--east, .advanced-cropper-simple-line--west {\n    height: 100%;\n    width: 0; }\n  .advanced-cropper-simple-line--east {\n    border-right-width: 1px; }\n  .advanced-cropper-simple-line--west {\n    border-left-width: 1px; }\n  .advanced-cropper-simple-line--south {\n    border-bottom-width: 1px; }\n  .advanced-cropper-simple-line--north {\n    border-top-width: 1px; }\n\n.advanced-cropper-simple-handler {\n  display: block; }\n\n.advanced-cropper-preview {\n  overflow: hidden;\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  flex-direction: column; }\n  .advanced-cropper-preview__content {\n    overflow: hidden;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%); }\n  .advanced-cropper-preview__image {\n    display: none;\n    pointer-events: none;\n    position: absolute;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    transform-origin: center;\n    max-width: none !important; }\n    .advanced-cropper-preview__image--visible {\n      display: block; }\n  .advanced-cropper-preview__boundary {\n    flex-grow: 1;\n    min-height: 0;\n    min-width: 0; }\n\n.cropper-preview-wrapper__fade {\n  flex-grow: 1;\n  min-height: 0;\n  width: 100%; }\n\n.advanced-cropper {\n  overflow: hidden;\n  max-height: 100%;\n  background: black;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  color: white; }\n  .advanced-cropper__boundary {\n    flex-grow: 1;\n    min-height: 0;\n    min-width: 0; }\n  .advanced-cropper__wrapper, .advanced-cropper__background-wrapper {\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    position: absolute; }\n  .advanced-cropper__stencil-wrapper {\n    position: absolute; }\n  .advanced-cropper * {\n    box-sizing: border-box; }\n\n.advanced-cropper-simple-handler {\n  background: currentColor;\n  height: 10px;\n  width: 10px; }\n\n.advanced-cropper-simple-line {\n  transition: border 0.5s;\n  border-color: rgba(255, 255, 255, 0.3);\n  border-style: solid; }\n  .advanced-cropper-simple-line--hover {\n    border-color: white; }\n\n.advanced-cropper-circle-stencil__preview {\n  border: solid 2px rgba(255, 255, 255, 0.2); }\n\n.advanced-cropper-stencil-overlay {\n  color: rgba(0, 0, 0, 0.5); }\n\n.advanced-cropper-stencil-grid {\n  color: rgba(255, 255, 255, 0.4); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
